import { isRunningInDesktop } from 'conversations/utils/PlatformUtil'
import { createBrowserHistory, createHashHistory, createMemoryHistory } from 'history'
import { isDev, isQa } from 'shared/utils/environment'

import { GlobalStore } from '@driftt/traffic-control'

export const history = (function () {
  if (isRunningInDesktop) {
    return createHashHistory()
  } else if (process.env.JEST_WORKER_ID !== undefined) {
    return createMemoryHistory()
  } else {
    return createBrowserHistory()
  }
})()

if (isDev || isQa || window.Cypress) {
  window.store = GlobalStore
}
